import styles from "./Comment.module.css";
import chat from "../../assets/chat.png";
import { customerService } from "../../services/customer.service";
import { useEffect, useState } from "react";
import { useNavigate,  useLocation } from "react-router-dom";
import { Table, Input } from 'antd';
import { formatCustomDate } from "../../helpers/formatCustomDate";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";


const { Search } = Input;



const columns = [
  {
    title: 'Ref No',
    key: 'History_Ref_No',
    dataIndex: 'History_Ref_No',
  className: "text-primary",
  sorter: (a, b) => (a?.History_Ref_No ?? '') - (b?.History_Ref_No ?? '')
  },

    
  {
    title: "History Date",
    dataIndex: "History_Date",
    sorter: (a, b) => (a?.History_Date ?? '').localeCompare(b?.History_Date ?? ''),
  },

  {
    title: "Type",
    dataIndex: "History_Type_Name",
    sorter: (a, b) => (a?.History_Type_Name ?? '').localeCompare(b?.History_Type_Name ?? '')
  },

  {
    title: "Description",
    dataIndex: "History_Description",
    sorter: (a, b) => (a?.History_Description ?? '').localeCompare(b?.History_Description ?? '')

  },
  {
    title: "Created By",
    dataIndex: "History_Created_By_Name",
    sorter: (a, b) => (a?.History_Created_By_Name ?? '').localeCompare(b?.History_Created_By_Name ?? '')
  },

];








function CustomerDetailsHistory(props) {
  const { customer_id } = props;
  const [history, setHistory] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const { pathname } = useLocation();
  const navigate = useNavigate();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    let isMounted = true;
    customerService.customerDetailsHistory(customer_id).then((res) => {
      if (isMounted && res?.data) {
        const  customizeData =  res.data.map((record)=> {
          return {...record, History_Created_By: record.History_Created_By?.toString()}
        })
        setHistory(customizeData);
        setFilteredData(customizeData);

      }
    });
    return () => {
      isMounted = false;
    };
  }, [customer_id]);




  const handleRowClick = (record) => {
    // navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${record?.IVR_Id}`);
  };


  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = history.filter((record) =>
      Object.values(record).some((text) =>
        String(text).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };






  return (
    <>
      <div className="mt-4 p-4 w-full bg-white @container">
        <div className="">
        <Search
        placeholder="Search..."
        onSearch={handleSearch}
        onChange={(e) => handleSearch(e.target.value)}
        value={searchText}
        style={{ marginBottom: 10, width: 250 }}
      />


                             <section className="mt-5">
                      
                                      <GeneralCustomTable
                                          tableHeadList={columns} 
                                          tableDataList={filteredData}
                                          allowCheckBox={false} // show checkBox for each row
                                          // setSelectedRows={selectCustomer}
                                          rowKey={(record) => record.History_Ref_No} // custom key
                                          handleRowClick={handleRowClick}
                                            />
                                        </section>

        </div>
      </div>
    </>
  );
}

export default CustomerDetailsHistory;
